export default __webpack_public_path__ + "static/media/browse-menu.83cfe5bf.svg";